import React from 'react'

import { StatisticsCardProps } from './statistics-card.d';

import StatisticsCard from '/react4xp/components/StatisticsCard';

function StatisticsCardPart(props: StatisticsCardProps) {
    return <StatisticsCard {...props} />
}

export default (props) => <StatisticsCardPart {...props} />
